<div class="container">
<h1>{{organization.printable_name}} Terms of Use</h1>
    <p>By using this web site ("Service"), you are agreeing to be bound by the following terms and conditions ("Terms of Use").</p>
    <p><strong>IF YOU DO NOT AGREE WITH THESE TERMS AND CONDITIONS, YOU MUST NOT ACCEPT THIS AGREEMENT AND MAY NOT USE THE SERVICE.</strong></p>
    <p>Violations of any of the terms below will result in the termination of your Account. You agree to use the Service at your own risk.</p>

    <h2>1. Account Terms</h2>
    <ul>
        <li>Your user account may only be used by one person. A single account shared by multiple users is not permitted.</li>
        <li>You are responsible for maintaining the security of your username and password. {{organization.printable_name}} cannot and will not be liable for any loss or damage resulting from your failure to comply with this security obligation.</li>
        <li>You must not use the Service to carry on any illegal or unauthorized activities.</li>
    </ul>

    <h2>2. Payment and Refunds</h2>
    <ul>
        <li>Beyond the initial trial credit, you must enter a valid credit card to pay the monthly balance due on an Organization's account.</li>
        <li>There will be no refunds for payments of the monthly usage charges.</li>
    </ul>

    <h2>3. Cancellation and Termination</h2>
    <ul>
        <li>You are solely responsible for properly canceling accounts. An email or phone request to cancel an account is not considered cancellation.</li>
        <li>If you delete an Account, all associated content will be immediately deleted from the Service and cannot be recovered.</li>
        <li>{{organization.printable_name}}, in its sole discretion, has the right to suspend or terminate an Account at any time.</li>
        <li>{{organization.printable_name}} reserves the right to refuse service to anyone for any reason at any time.</li>
    </ul>

    <h2>4. Copyright and Content Ownership</h2>
    <ul>
        <li>We claim no intellectual property rights over the material you provide to the Service. Your materials remain yours.</li>
        <li>You shall defend {{organization.printable_name}} against any claims related to your content infringing third-party rights.</li>
        <li>You shall indemnify {{organization.printable_name}} for any damages resulting from such claims.</li>
    </ul>

    <h2>5. Privacy</h2>
    <ul>
        <li>We collect information only to provide and improve the Service.</li>
        <li>We will not sell personally identifiable information to third parties.</li>
        <li>We may disclose information under legal obligations or when actions violate these Terms.</li>
        <li>Cookies are required to use the Service.</li>
    </ul>

    <h2>6. General Conditions</h2>
    <ul>
        <li>You use the Service at your own risk. It is provided "as is" and "as available."</li>
        <li>You agree not to reproduce, modify, sell, or resell the Service without express permission.</li>
        <li>Do not hack or falsely imply association with {{organization.printable_name}}.</li>
        <li>Questions about the Terms of Use should be sent to {{organization.email}}.</li>
    </ul>
</div>
